// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"Dropdown_dropdownContainer__zL+Ee","placeholderContainer":"Dropdown_placeholderContainer__Mx3Tt"};